// extracted by mini-css-extract-plugin
export default {"main__container":"MainContent_main__container__DBvkH"};